import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import HighProfileDomains from './HighProfileDomains';
import HighProfileUserExceptionList from './HighProfileUserExceptionList';
import HighProfileUser from './HighProfileUser';

const HighProfileList = () => {
  const { t } = useTranslation();
  return (
    <Tabs px="4x">
      <TabList>
        <Tab>{t('globalSetting.highProfileDomains.tab.title')}</Tab>
        <Tab>{t('globalSetting.highProfileUsers.tab.title')}</Tab>
        <Tab>{t('globalSetting.highProfileUsersExceptions.tab.title')}</Tab>
      </TabList>

      <TabPanels px="3x" py="2x">
        <TabPanel>
          {(args: any) =>
            !args.isSelected ? null : (
              <Box>
                <HighProfileDomains></HighProfileDomains>
              </Box>
            )
          }
        </TabPanel>
        <TabPanel>
          {(args: any) =>
            !args.isSelected ? null : (
              <Box>
                <HighProfileUser></HighProfileUser>
              </Box>
            )
          }
        </TabPanel>
        <TabPanel>
          {(args: any) =>
            !args.isSelected ? null : (
              <Box>
                <HighProfileUserExceptionList></HighProfileUserExceptionList>
              </Box>
            )
          }
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};
export default HighProfileList;
